var EmailChannelDataBuilder = /** @class */ (function () {
    function EmailChannelDataBuilder() {
        this.emailChannelData = {
            mailboxId: 'some-id',
            mailboxEmail: 'bob@bob.com',
            attachments: []
        };
    }
    EmailChannelDataBuilder.prototype.withMailboxId = function (mailboxId) {
        this.emailChannelData.mailboxId = mailboxId;
        return this;
    };
    EmailChannelDataBuilder.prototype.withMailboxEmail = function (mailboxEmail) {
        this.emailChannelData.mailboxEmail = mailboxEmail;
        return this;
    };
    EmailChannelDataBuilder.prototype.withAttachments = function (attachments) {
        this.emailChannelData.attachments = attachments;
        return this;
    };
    EmailChannelDataBuilder.prototype.build = function () {
        return this.emailChannelData;
    };
    return EmailChannelDataBuilder;
}());
export { EmailChannelDataBuilder };
//# sourceMappingURL=email-channel-data.builder.js.map